var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5H2.5V35C2.5 35.663 2.76339 36.2989 3.23223 36.7678C3.70107 37.2366 4.33696 37.5 5 37.5H37.5V35H5V2.5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 11.25H28.75V13.75H33.2375L23.75 23.2375L18.3875 17.8625C18.2713 17.7453 18.133 17.6523 17.9807 17.5889C17.8284 17.5254 17.665 17.4928 17.5 17.4928C17.335 17.4928 17.1716 17.5254 17.0193 17.5889C16.867 17.6523 16.7287 17.7453 16.6125 17.8625L7.5 26.9875L9.2625 28.75L17.5 20.5125L22.8625 25.8875C22.9787 26.0047 23.117 26.0977 23.2693 26.1611C23.4216 26.2246 23.585 26.2572 23.75 26.2572C23.915 26.2572 24.0784 26.2246 24.2307 26.1611C24.383 26.0977 24.5213 26.0047 24.6375 25.8875L35 15.5125V20H37.5V11.25Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonReports);
export default __webpack_public_path__ + "static/media/NonReports.0ef31028a3935bc50316cd5123830c0c.svg";
export { ForwardRef as ReactComponent };